var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"result-container"},[_c('img',{staticClass:"result-img",attrs:{"src":_vm.resultUrl,"alt":""}}),_c('div',{staticClass:"result-text"},[_vm._v(_vm._s(_vm.resultNull))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }